import { render, staticRenderFns } from "./SuperCollectionProductTiles.vue?vue&type=template&id=52ed5895&scoped=true&lang=pug&"
import script from "./SuperCollectionProductTiles.vue?vue&type=script&lang=js&"
export * from "./SuperCollectionProductTiles.vue?vue&type=script&lang=js&"
import style0 from "./SuperCollectionProductTiles.vue?vue&type=style&index=0&id=52ed5895&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52ed5895",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/jackie/sites/cardinalco/ylang-23/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('52ed5895')) {
      api.createRecord('52ed5895', component.options)
    } else {
      api.reload('52ed5895', component.options)
    }
    module.hot.accept("./SuperCollectionProductTiles.vue?vue&type=template&id=52ed5895&scoped=true&lang=pug&", function () {
      api.rerender('52ed5895', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/scripts/components/pages/SuperCollection/SuperCollectionProductTiles.vue"
export default component.exports